import type { PublicApiKey } from '@/apilib';
import type { createConcurrentUsersApi } from './concurrentUsersWrapper';

export const ConcurrentUsersApiKey: PublicApiKey<
  typeof createConcurrentUsersApi
> = {
  name: 'ConcurrentUsersApi',
  public: true,
};
